import {
  Card,
  CardActionArea,
  CardContent,
  styled,
  Box,
  Fade,
} from '@mui/material'
import { ReactNode, memo, useMemo, useState } from 'react'
import Image from 'next/image'
import { Text } from '@components/Helpers'
import { useTranslation } from 'react-i18next'
import { useAsync } from 'react-async-hook'

const Root = styled(Card)({
  borderColor: 'var(--dewi_colors_gray_8) !important',
  borderWidth: 2,
  transition: 'all .2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.03)',
  },
  position: 'relative',
})

const ActionArea = styled(CardActionArea)(() => ({
  position: 'relative',
  display: 'contents',
}))

const CardImage = styled(Image)(() => ({
  borderRadius: 500,
  height: 70,
}))

function TokenCardContent({ children }: { children: ReactNode }) {
  const StyledCardContent = styled(CardContent)(() => ({
    paddingTop: 0,
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  }))
  return <StyledCardContent>{children}</StyledCardContent>
}

function TokenCardText({ children }: { children: ReactNode }) {
  const TextContainer = styled(Box)({
    border: '1px solid #424242',
    backgroundColor: '#0E0F13',
    borderRadius: 5,
    padding: 10,
  })

  return (
    <TextContainer>
      <Text
        sx={{
          textAlign: 'center',
          fontWeight: 'normal',
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 1,
        }}
      >
        {children}
      </Text>
    </TextContainer>
  )
}

function DabbaTokenCard() {
  const { t } = useTranslation()
  const [calculatedColor, setCalculatedColor] = useState<string | undefined>()
  const [calculatedGradient, setCalculatedGradient] = useState<
    string | undefined
  >()

  const amount = useMemo(() => {
    // Starting from Dec 10th add 1000 every day
    const startDate = new Date('2024-12-9')
    const today = new Date()
    const days = Math.floor(
      (today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24),
    )
    return days * 1000
  }, [])

  useAsync(async () => {
    try {
      const newColor = 'rgba(255, 217, 3, 0.4)'
      const gradientColor = 'rgba(255, 217, 3, 0.2)' // create black and calculated color gradient
      const newGradient = `linear-gradient(0deg, #000000 0%, ${gradientColor} 100%)`
      setCalculatedGradient(newGradient)

      setCalculatedColor(newColor)
    } catch (err) {
      console.error(err)
    }
  }, [])

  return (
    <Fade in timeout={1000}>
      <Box>
        <Root
          sx={{
            background: calculatedGradient,
          }}
        >
          <ActionArea>
            <Box
              padding={0.5}
              position="absolute"
              top={-25}
              left={20}
              sx={{
                background: calculatedColor,
                borderRadius: 500,
              }}
            >
              <CardImage
                alt={'Dabba Logo'}
                width={70}
                height={70}
                src={require('@assets/dabbaLogo.jpg')}
              />
            </Box>
            <Box height={150} display={'flex'}>
              <div className="p-3 flex flex-col justify-end w-full">
                <h5 className="text-gray-5 text-size-2 font-space text-left mt-12 w-full">
                  {`${amount?.toLocaleString()} `}
                  <span className="text-gray-1">DABBA</span>
                </h5>
                <h5 className="text-gray-5 text-size-2 font-space text-left w-full">
                  {t('components.tokenCard.noPriceAvailable')}
                </h5>
              </div>
            </Box>
            <Fade in={true} timeout={1000}>
              <Box>
                <TokenCardContent>
                  <TokenCardText>WiFi Dabba</TokenCardText>
                </TokenCardContent>
              </Box>
            </Fade>
          </ActionArea>
        </Root>
      </Box>
    </Fade>
  )
}

export default memo(DabbaTokenCard)
